type IssueContext = {
    addIssue: (issue: { code: 'custom'; path: string[]; message: string }) => void;
};

// Pronouns are stored as a single free-text string, so a published contract cannot see whether
// "Other" is the selected choice and accepts null and any non-empty string. The form encodes "Other
// selected, nothing typed" as the empty string — `pronouns-fields.tsx` writes it the moment Other is
// picked and nothing else ever produces it — so rejecting `''` here *is* that UI rule.
//
// It has to sit on the resolver rather than in the component: react-hook-form ignores field-level
// `rules` whenever a resolver is supplied, so a check living only in the component could show a
// message but never disable save.
export function rejectEmptyPronouns(value: { pronouns?: string | null }, ctx: IssueContext) {
    if (value.pronouns === '') {
        ctx.addIssue({ code: 'custom', path: ['pronouns'], message: 'Enter pronouns' });
    }
}
